module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "full-width-image",
    attrs: {
      "id": "preview_cover"
    }
  }, [_c('span', [_c('img', {
    staticClass: "svg1",
    attrs: {
      "alt": "image",
      "src": "images/Brooks_the_Pied_Piper_02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_vm._v("“"), _c('i', [_vm._v("There, you see?” he said. “Two cents")]), _vm._v("—"), _c('i', [_vm._v("that’s his price")]), _vm._v(".”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d58464e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/franmatter01.vue
// module id = 57
// module chunks = 0